<template>
  <header id="header_" class="section-box-header fixed">
    <div class="container-fluid">
      <div v-if="hasUser" class="row align-items-center">
        <div v-show="showMenuToggle" class="col-auto">
          <div @click="toggleMainMenu" class="main-menu-button">
            <div class="animate-main-menu-bl">
              <div class="top"></div>
              <div class="center"></div>
              <div class="bottom"></div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4 col-xl-2 logo">
          <div class="logo-button-wrapp">
            <router-link to="/stations">
              <img src="../../assets/images/logo.svg" alt="">
            </router-link>
          </div>
        </div>
        <div class="d-xl-block d-none col-lg-1"></div>
        <div class="d-none d-lg-block col">
          <div class="header-menu">
            <Menu :user="user"></Menu>
          </div>
        </div>
        <div class="d-lg-block col-auto text-center">
          <div class="logout-text">
            <a href="#">{{ user.name }}</a>
          </div>
          <div @click="performLogout()" class="login-header-wr">
            <a href="#" class="login-header"></a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Menu from './Menu.vue'

export default {

  name: 'Header',
  components: {
    Menu
  },
  props: {
    testParam: Boolean
  },
  data () {
    return {
      mobMenu: true
    }
  },
  methods: {
    performLogout () {
      this.$store.dispatch('security/logout')
      this.$router.push({ path: '/login' })
    },
    toggleMainMenu () {
      this.$store.dispatch('common/toggleMainMenu')
    }
  },
  computed: {
    user () {
      return this.$store.getters[ 'user/user' ]
    },
    hasUser () {
      return this.$store.getters[ 'user/hasUser' ]
    },
    userLoading () {
      return this.$store.getters[ 'user/isLoading' ]
    },
    menuOpened () {
      return this.$store.getters[ 'common/menuIsOpened' ]
    },
    hasStation () {
      return this.$store.getters[ 'station/hasStation' ]
    },
    showMenuToggle () {
      return this.$route.meta.noMenu !== true
    }
  },
  created () {
    this.$store.dispatch('user/fetch')
  }
}
</script>
